<template>
  <div class="cardOfNew">
      <div class="tipContent">
          <div class="title">请在“微信公众平台”选择行业为：“IT科技 - 互联网|电子商务”，搜索标题为：“充值”，添加模板编号为：“xxxxxxxxxxxxxxx”的模板。</div>
          <div class="tipDetail">
            <p :key="index" v-for="(item,index) in tipContents">{{index+1+'.'+item}}</p>
          </div>
      </div>
      <div class="cardContent">
        <div class="card" :key="cardItemIndex" v-for="(cardItem,cardItemIndex) in cards">
            <div class="topPart">
                <el-input placeholder='输入模板标题' v-model="cardItem.templateTitle"></el-input>
                <div class="tipArea">
                    <div class="tipInfo" :key="index" v-for="(tipItem,index) in cardItem.tipContents">
                        <div>{{tipItem.label}}：</div>
                        <div>{{tipItem.value}}</div>
                    </div>
                </div>
                <el-input v-model="cardItem.templateRemark" placeholder='输入模板备注'></el-input>
            </div>
            <div class="bottomPart">
                <div class="tipInfo">
                    <div>模板编号：</div>
                    <div>{{cardItem.templateSerialNumber}}</div>
                </div>
                <el-input style="margin-top:6px" v-model="cardItem.templateId" placeholder='输入模板id'></el-input>
                <div class='footerBtn'  @mouseenter="currentCardItemIndex=cardItemIndex">
                    <el-switch
                        @change="isUseTheTemplate(cardItemIndex)"
                        v-model="cardItem.templateSwitch"
                        active-color="#409EFF"
                        inactive-color="#DCDFE6">
                    </el-switch>
                    <el-button type='primary' @click="openColorBox(cardItemIndex)">颜色</el-button>
                    <el-button type='primary' @click="saveTemplateConfig(cardItemIndex)">保存</el-button>
                </div>
            </div>
        </div>
      </div>

       <!--颜色选择模态框 -->
        <el-dialog
            title="颜色选择"
            :visible.sync="colorSelectVisible"
            width="17%"
            custom-class="colorSelectBox"
            :close-on-click-modal='false'
            :before-close='colorSelectBoxClose'
            v-loading='false'
        >
            <div v-if="cards[currentCardItemIndex]" class="colorSelectBody">
                <div class="colorLine">
                    <div class="label">标题区</div>
                    <div class="colorValue">{{cards[currentCardItemIndex].templateTitleColor}}</div>
                    <div class="colorPicker"><el-color-picker v-model="cards[currentCardItemIndex].templateTitleColor"></el-color-picker></div>
                </div>
                <div class="colorLine">
                    <div class="label">内容区</div>
                    <div class="colorValue">{{cards[currentCardItemIndex].tipValueColor}}</div>
                    <div class="colorPicker"><el-color-picker v-model="cards[currentCardItemIndex].tipValueColor"></el-color-picker></div>
                </div>
                <div class="colorLine">
                    <div class="label">备注区</div>
                    <div class="colorValue">{{cards[currentCardItemIndex].templateRemarkColor}}</div>
                    <div class="colorPicker"><el-color-picker v-model="cards[currentCardItemIndex].templateRemarkColor"></el-color-picker></div>
                </div>
            </div>
            <div class="colorSelectFooter" style="text-align:right">
                <el-button type="primary" @click="colorSelectConfirm()">确定</el-button>
            </div>
        </el-dialog>
  </div>
</template>

<script>
  import api from '@/config/api';

  export default {
  data(){
      //没点保存之前它操作的是一个备份
      let cards=[];
      for(let i=0;i<this.cardOfNewOptions.length;i++){
          let objectDeep={
            ...this.cardOfNewOptions[i]
          }
          cards.push(objectDeep);
      }
      console.log('当前cards',cards);
      return{
        message:'',//操作成功与否的提示
        colorSelectVisible:false,
        currentCardItemIndex:0,//打开颜色框时确定当前在数组哪个元素下
        tipContents:[
            '变量{shopname}将替换成门店名称或商户名称(如：测试门店)。例：谢谢惠顾，{shopname}祝你生活愉快！',
            '变量{vipname}将替换成会员名称(如：张三)。例：尊敬的{vipname},你已成功激活会员卡：',
            '变量{phone}将替换成会员手机号(如：13400000000)。例：您用{phone}的手机手机号注册了本店的会员：',
            '变量只用于模板标题或注释部分！'
        ],
        cards,
      }
  },
  created(){
    console.log('jdsfjdsa ',this.cardOfNewOptions)
  },
  props:['cardOfNewOptions'],
  methods:{
    //是否开启该模板
    async isUseTheTemplate(cardItemIndex){
        //先行保存
        await this.saveTemplateConfig(cardItemIndex);
        //开启该模板其他模板将关闭后台处理，前台界面优化
        if(this.cards[cardItemIndex].templateSwitch){//当前是开启状态则其它模板关闭
          for(let i=0;i<this.cards.length;i++){
              if(i!=cardItemIndex){
                  this.cards[i].templateSwitch=false;
              }
          }
        }
        let data={
            id: this.cardOfNewOptions[cardItemIndex].cardInfo.id,
            use: this.cards[cardItemIndex].templateSwitch?1:0
        }
        let param = {
            data: JSON.stringify(data),
            model: this.cardOfNewOptions[cardItemIndex].type
        };
        let url=api.system.newTemplateUpdate;
        this.$axios.fetchPost(url,param).then((res)=>{
            if(res.code===200){
              this.$notify({
                type: "success",
                title: '模板开启操作',
                message: '成功',
                showClose: false,
              });
              // this.$message({
              //     message:'模板开启成功！',
              //     type:'success'
              // })
            }else{
              this.$notify({
                type: "error",
                title: '模板开启操作',
                message: '失败',
                showClose: false,
              });
              // this.$message.error('模板开启失败！'+res.errorMsg);
            }
        })
    },
    //保存当前配置直到调用从新加载该部分数据的接口
    async saveTemplateConfig(cardItemIndex){
      this.currentCardItemIndex=cardItemIndex;
      this.cardOfNewOptions[cardItemIndex]=this.copyObject(this.cards[cardItemIndex])

      let data={
        id: this.cardOfNewOptions[cardItemIndex].cardInfo.id,
        templateNumber: this.cardOfNewOptions[cardItemIndex].cardInfo.templateNumber,
        templateTitle: this.cardOfNewOptions[cardItemIndex].templateTitle,
        templateRemark: this.cardOfNewOptions[cardItemIndex].templateRemark,
        templateId: this.cardOfNewOptions[cardItemIndex].templateId,

        memberNumber: this.cardOfNewOptions[cardItemIndex].cardInfo.memberNumber,
        memberRank: this.cardOfNewOptions[cardItemIndex].cardInfo.memberRank,
        memberName: this.cardOfNewOptions[cardItemIndex].cardInfo.memberName,
        memberPhone: this.cardOfNewOptions[cardItemIndex].cardInfo.memberPhone,
        memberAddtime: this.cardOfNewOptions[cardItemIndex].cardInfo.memberAddtime,
        memberBalance: this.cardOfNewOptions[cardItemIndex].cardInfo.memberBalance,
        rechargeAddtime:this.cardOfNewOptions[cardItemIndex].cardInfo.rechargeAddtime,
        rechargeMode:this.cardOfNewOptions[cardItemIndex].cardInfo.rechargeMode,
        rechargeMoney:this.cardOfNewOptions[cardItemIndex].cardInfo.rechargeMoney,
        rechargeNumber:this.cardOfNewOptions[cardItemIndex].cardInfo.rechargeNumber,
        rechargeStatus:this.cardOfNewOptions[cardItemIndex].cardInfo.rechargeStatus,
        memberIntegral:this.cardOfNewOptions[cardItemIndex].cardInfo.memberIntegral,
        consumeAddtime:this.cardOfNewOptions[cardItemIndex].cardInfo.consumeAddtime,
        consumeMoney:this.cardOfNewOptions[cardItemIndex].cardInfo.consumeMoney,
        orderNumber:this.cardOfNewOptions[cardItemIndex].cardInfo.orderNumber,
        consumeMode:this.cardOfNewOptions[cardItemIndex].cardInfo.consumeMode,
        discountsName:this.cardOfNewOptions[cardItemIndex].cardInfo.discountsName,
        expirationDate:this.cardOfNewOptions[cardItemIndex].cardInfo.expirationDate,
        provideDate:this.cardOfNewOptions[cardItemIndex].cardInfo.provideDate,
        refundMoney: this.cardOfNewOptions[cardItemIndex].cardInfo.refundMoney,
        refundTime: this.cardOfNewOptions[cardItemIndex].cardInfo.refundTime,
        refundType: this.cardOfNewOptions[cardItemIndex].cardInfo.refundType,

        use: this.cardOfNewOptions[cardItemIndex].templateSwitch?1:0,
        type: this.cardOfNewOptions[cardItemIndex].type,
        titlecolor: this.cardOfNewOptions[cardItemIndex].templateTitleColor,
        bodycolor: this.cardOfNewOptions[cardItemIndex].tipValueColor,
        remarkcolor: this.cardOfNewOptions[cardItemIndex].templateRemarkColor
      }
      let param = {
          data: JSON.stringify(data),
          model: data.type
      };
      let url=api.system.newTemplateUpdate;
      const loading=this.$loading();
      await this.$axios.fetchPost(url,param).then((res)=>{
          loading.close();
          if(res.code===200){
            this.$notify({
              type: "success",
              title: '保存操作',
              message: '成功',
              showClose: false,
            });
            // this.$message({
            //     message:'保存成功！',
            //     type:'success'
            // })
          }else{
            this.$notify({
              type: "error",
              title: '保存操作',
              message: '失败',
              showClose: false,
            });
            // this.$message.error('保存失败！'+res.errorMsg);
          }
      })
      console.log(JSON.stringify(data),'保存后',this.cardOfNewOptions)
    },
    copyObject(object){
      let newObject={};
      for(let attr in object){
        newObject[attr]=object[attr];
      }
      return newObject;
    },
    //确定选择的颜色
    colorSelectConfirm(){
       this.colorSelectVisible=false;
    },
    //点击小叉关闭放弃选择的颜色
    colorSelectBoxClose(done) {
        done();
        //把原来的颜色置空回来
        this.cardOfNewOptions[this.currentCardItemIndex].templateTitleColor='';
        this.cardOfNewOptions[this.currentCardItemIndex].tipValueColor='';
        this.cardOfNewOptions[this.currentCardItemIndex].templateRemarkColor='';
    },
    openColorBox(cardItemIndex){
        this.currentCardItemIndex=cardItemIndex;
        this.colorSelectVisible=true;
    }
  }
}
</script>

<style scoped>
.cardOfNew{

}

.tipContent{

}

.tipContent .title{
  padding: 15px;
  height: 50px;
  background-color: #f1f1f1;
}
.tipContent .tipDetail{
    height: 120px;
    padding: 15px;
    border:1px solid #e6e6e6;
}

.cardContent{
    padding: 10px;
    display: flex;
    flex-flow: row wrap;
}
.cardContent .card{
    width: 300px;
    height: 333px;
    padding: 15px 25px;
    border: 1px solid #f1f1f1;
    box-sizing: border-box;
    margin-right:20px;
}
.cardContent .card .topPart{
    height: 200px;
    border-bottom: 2px solid #ddd;
}
.cardContent .card .tipArea{
    margin-bottom: 6px;
}
.cardContent .card .tipInfo{
    margin-top: 6px;
}
.cardContent .card .tipInfo div{
    display: inline-block;

    font-size: 12px;
    color: #424242;
}
.cardContent .card .tipInfo div:nth-of-type(1){
    width: 66px;
}
.cardContent .card .tipInfo div:nth-of-type(2){

}

.cardContent .card .bottomPart .footerBtn{
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-around;
    align-items: center;
    margin-top:6px;
}
.colorSelectBox .colorLine{
    height:38px;
    line-height: 34px;
    text-align: center;
    margin-bottom: 15px;

    font-size: 14px;
    color:#424242;
}
.colorSelectBox .colorLine .label{
    display: inline-block;
    width: 110px;

}
.colorSelectBox .colorLine .colorValue{
    display: inline-block;
    width: 120px;
    height: 36px;
    border: 1px solid #E6E6E6;
    background-color: #ffffff;
    vertical-align: bottom;
}

.colorSelectBox .colorLine .colorPicker{
    display: inline-block;
    width: 38px;
    height: 38px;
    vertical-align: bottom;
}

.el-select, .el-input, .el-input-number{
    width: 100%;
}
.cardOfNew>>>.colorSelectBox{
  min-width: 17%;
  width: 17%;
}
.cardOfNew>>>.el-color-picker__trigger{
    width: 38px;
    height: 38px;
}
.cardOfNew>>>.el-color-picker{
    height: 38px;
}
</style>



// WEBPACK FOOTER //
// src/page/system/wechat/CardOfNew.vue